export const hasPhone = (form) => {
    const fields = form.fields || [];
    return fields.some((field) => ['BOOKINGS_PHONE', 'CONTACTS_PHONE', 'DEXT_PHONE', 'ECOM_PHONE'].includes(field.view?.fieldType));
};
//# sourceMappingURL=has-phone.js.map